import type { ItemWithUpdatedFields } from 'types/nesting'
import type { State } from 'types/redux'
import type { Track, TrackId } from 'types/track'
import { getUpdatedFieldsEntries } from '@disco/utils/nesting'
export type ManageNestingFormState = {
  itemsWithUpdatedFields: Record<TrackId, ItemWithUpdatedFields>
  submitting: boolean
  error: Error | null | undefined
  tracks: Track[] | null | undefined
  mainTrackId: TrackId | null | undefined
}
export const getManageNestingForm: (
  arg0: State,
) => ManageNestingFormState = state => state.forms.manageNesting
const initialState: ManageNestingFormState = {
  submitting: false,
  error: null,
  itemsWithUpdatedFields: {},
  tracks: [],
  mainTrackId: null,
}
const MANAGE_NESTING_FORM_UPDATE = 'MANAGE_NESTING_FORM_UPDATE'
const MANAGE_NESTING_FORM_RESET = 'MANAGE_NESTING_FORM_RESET'
type UpdateManageNestingFormAction = {
  type: typeof MANAGE_NESTING_FORM_UPDATE
  update: Partial<ManageNestingFormState>
}
type ResetManageNestingFormAction = {
  type: typeof MANAGE_NESTING_FORM_RESET
}
type ActionTypes = UpdateManageNestingFormAction | ResetManageNestingFormAction
export const updateManageNestingForm: (
  update: Partial<ManageNestingFormState>,
) => UpdateManageNestingFormAction = update => ({
  update,
  type: MANAGE_NESTING_FORM_UPDATE,
})
export const resetManageNestingForm: () => ResetManageNestingFormAction =
  () => ({
    type: MANAGE_NESTING_FORM_RESET,
  })
// TODO: refactor in https://disco-team.atlassian.net/browse/DISCO-6252
// see packages/frontend/src/utils/nesting.js for the list of actions to be refactored
// - get away from using single action type for multiple actions in a reducer
// - move state updates to the specific action handlers
export const manageNestingFormReducer: (
  arg0: ManageNestingFormState,
  arg1: any,
) => ManageNestingFormState = (
  state: ManageNestingFormState = initialState,
  action: ActionTypes,
) => {
  switch (action.type) {
    case MANAGE_NESTING_FORM_UPDATE: {
      let mainTrackId = action.update.mainTrackId ?? state.mainTrackId
      if (mainTrackId && typeof mainTrackId !== 'number')
        mainTrackId = Number(mainTrackId)
      let itemsWithUpdatedFields = {
        ...state.itemsWithUpdatedFields,
        ...action.update.itemsWithUpdatedFields,
      }
      // ensure that we set all values nesting_parent_id to main track id
      itemsWithUpdatedFields = getUpdatedFieldsEntries(
        itemsWithUpdatedFields,
      ).reduce((acc, [key, value]) => {
        return {
          ...acc,
          [key]: {
            ...value,
            nesting_parent_id:
              Number(key) !== mainTrackId && value.nesting_parent_id
                ? mainTrackId
                : null,
            nesting_label:
              Number(key) === mainTrackId ? 'Main' : value.nesting_label,
          },
        }
      }, {})
      return {
        ...state,
        ...action.update,
        itemsWithUpdatedFields,
        mainTrackId,
      }
    }
    case MANAGE_NESTING_FORM_RESET:
      return initialState

    default:
      return state
  }
}
